<template>
  <div>
    <!-- Mobile: Select dropdown -->
    <div class="sm:hidden mb-3">
      <select
        class="defaultInput w-full"
        :value="modelValue"
        @change="selectTab($event.target.value)"
      >
        <option v-for="tab in tabs" :key="tab.id || tab.name" :value="tab.name">
          {{ tab.label || tab.name }}
        </option>
      </select>
    </div>

    <!-- Desktop: Tab navigation -->
    <div class="hidden sm:block pb-4">
      <div class="border-b border-gray-200">
        <nav class="flex gap-4 -mb-px overflow-x-auto" aria-label="Tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id || tab.name"
            @click="selectTab(tab.name)"
            type="button"
            class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors"
            :class="[
              modelValue === tab.name
                ? 'border-gray-700 text-gray-900'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            ]"
          >
            {{ tab.label || tab.name }}
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleTabs",

  props: {
    tabs: {
      type: Array,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue', 'change'],

  methods: {
    selectTab(tabName) {
      this.$emit('update:modelValue', tabName);
      this.$emit('change', tabName);
    }
  }
}
</script>

<style scoped>
nav {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

nav::-webkit-scrollbar {
  display: none;
}
</style>
